<template>
  <div>
    <div class="bottom-line" v-if="page <= 4">
      <img :src="path+('bottom-line.png')">
    </div>
    <!--維持器問題-->
    <div class="test-p3 rd-test" v-if="page <= 4">
      <div class="card-area"
           @mousedown="handleMouseDown"
           @mouseup="handleMouseUp"
           @mousemove="handleMouseMove"
           @touchstart="handleTouchStart"
           @touchend="handleTouchEnd">
        <!--點擊yes就給yes no就給no 點擊同時下一張要加上now-->
        <div class="card-item t3pic1 firstcard" v-bind:class="{yes: answers[0].answer === true,no: answers[0].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-17.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-17.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q1.svg')">
                  </div>
                  <h2>
                    近距離接觸擔心牙套有異味
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t3pic2" v-bind:class="{now: page === 2 || page === 3, yes: answers[1].answer === true,no: answers[1].answer === false}">
            <div class="rel-formove">
            <div class="shadow-area"></div>
            <div class="yes-mark">
                <img :src="path+('cry-18.gif')">
            </div>
            <div class="no-mark">
                <img :src="path+('smile-18.gif')">
            </div>
          <div class="full-mask"></div>
          <div class="ribbon-title">
            <div class="left-area">
              <div class="num-title">
                <img :src="path+('Q2.svg')">
              </div>
              <h2>
                漱口水錯誤清洗牙套
              </h2>
            </div>
            <div class="arrsvg">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
              </svg>
            </div>
          </div>
            </div>
        </div>
        <div class="card-item t3pic3" v-bind:class="{now: page === 3 || page === 4, yes: answers[2].answer === true,no: answers[2].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-19.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-19.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q3.svg')">
                  </div>
                  <h2>
                    牙套染色，不敢露齒笑
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t3pic4" v-bind:class="{now: page === 4 || page === 5, yes: answers[3].answer === true,no: answers[3].answer === false}">
            <div class="rel-formove">
            <div class="shadow-area"></div>
            <div class="yes-mark">
                <img :src="path+('cry-20.gif')">
            </div>
            <div class="no-mark">
                <img :src="path+('smile-20.gif')">
            </div>
          <div class="full-mask"></div>
          <div class="ribbon-title">
            <div class="left-area">
              <div class="num-title">
                <img :src="path+('Q4.svg')">
              </div>
              <h2>
                牙套很少在清潔
              </h2>
            </div>
            <div class="arrsvg">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
              </svg>
            </div>
          </div>
            </div>
        </div>
      </div>
      <div class="page-num">
        <p v-text="page">1</p>
        <span>/</span>
        <p>4</p>
      </div>
      <div class="yn-btn-area">
        <button class="nobtn" v-on:click="selectAnswer(false)">
          <img :src="path+('NOg.svg')">
        </button>
        <button class="yesbtn" v-on:click="selectAnswer(true)">
          <img :src="path+('YESg.svg')">
        </button>
      </div>
    </div>
    <!--維持器結果1 三星-->
    <div class="resbg rd-result" v-if="star === 3">
      <div class="mask-green"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp3-1.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon8.svg')">
            <p>講話擔心有異味，<br>
              又不敢自信微笑？</p>
            <img :src="path+('ficon9.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title9.svg')">
          </div>
        </div>
        <div class="pr-are">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip1.png')">
            </div>
            <h3 class="col-green">
              你需要強力社交幫手助攻，<br>
              讓你自信開口、成為社交潛力高手！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box">
                  <img :src="path+('pr6.png')">
                </div>
                <p>
                  異味就交給<span class="col-green">保麗淨口腔護具清潔錠</span>，五分鐘有效減少細菌孳⽣、牙菌斑堆積，減少牙套或維持器異味，並避免引起口腔問題！
                </p>
              </li>
            </ul>
            <div class="flex-center">
              <button class="share-result col-green" v-on:click="share(path+('Share_維持器問題_score_100-1.jpg'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="statement">
        如對產品有任何問題，請直接聯繫保麗淨消費者服務專線 0800-212-259。 使用前詳閱包裝外盒說明、警語及注意事項 北市衛器廣字第113030174號、衛署醫器輸壹字第001416號 保麗淨假牙黏著劑(未滅菌)、衛署醫器輸壹字第021850號保麗淨口腔護具清潔錠(未滅菌)、英商葛蘭素史克消費保健用品股份有限公司台灣分公司 台北市忠孝西路一段66號24樓 Trademarks owned by or licensed to Haleon group of companies. ©2024 Haleon group of companies or its licensor. PM-TW-POLD-24-00033
      </div>
    </div>
    <!--維持器結果2 五星-->
    <div class="resbg rd-result" v-if="star === 5">
      <div class="mask-green"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp3-2.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon8.svg')">
            <p>社交場如上戰場</p>
            <img :src="path+('ficon10.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title10.svg')">
          </div>
        </div>
        <div class="pr-are">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip1.png')">
            </div>
            <h3 class="col-green">
              想繼續當社交好手，各場面都得心應手 <br>
              就要保持自信開口的能力！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box">
                  <img :src="path+('pr6.png')">
                </div>
                <p>
                  記得使用<span class="col-green">保麗淨口腔護具清潔錠</span>，五分鐘有效減少細菌孳⽣、牙菌斑堆積，持續抵抗牙套或維持器異味，降低問題發生可能性！
                </p>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result col-green" v-on:click="share(path+('Share_維持器問題_score_100.jpg'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="statement">
        如對產品有任何問題，請直接聯繫保麗淨消費者服務專線 0800-212-259。 使用前詳閱包裝外盒說明、警語及注意事項 北市衛器廣字第113030174號、衛署醫器輸壹字第001416號 保麗淨假牙黏著劑(未滅菌)、衛署醫器輸壹字第021850號保麗淨口腔護具清潔錠(未滅菌)、英商葛蘭素史克消費保健用品股份有限公司台灣分公司 台北市忠孝西路一段66號24樓 Trademarks owned by or licensed to Haleon group of companies. ©2024 Haleon group of companies or its licensor. PM-TW-POLD-24-00033
      </div>
    </div>

  </div>
</template>

<script>
  import {gsap} from "gsap";
  import Vue from "vue";

  export default {
    props: ["path"],
    name:"RetainerTest",
    data() {
      return {
        page:1,
        answers:[
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          }
        ],
        star:0,
          touch:{
              enable:true,
              startX: 0,
              currentX: 0,
          }
      }
    },
    methods: {
        handleTouchStart(event) {
            this.touch.startX = event.touches[0].clientX;
        },
        handleTouchEnd(event) {
            let endX = event.changedTouches[0].clientX;
            this.detectDirection(endX - this.touch.startX);
        },
        handleMouseDown(event) {
            this.touch.startX = event.clientX;
            window.addEventListener('mousemove', this.handleMouseMove);
        },
        handleMouseMove(event) {
            this.touch.currentX = event.clientX;
        },
        handleMouseUp(event) {
            window.removeEventListener('mousemove', this.handleMouseMove);
            this.detectDirection(this.touch.currentX - this.touch.startX);
        },
        detectDirection(distance) {
            const threshold = 20;

            if(this.touch.enable){
                if (distance > threshold) {
                    this.touch.enable = false
                    this.touch.startX = 0
                    this.touch.currentX = 0
                    this.selectAnswer(true)
                } else if (distance < -threshold) {
                    this.touch.enable = false
                    this.touch.startX = 0
                    this.touch.currentX = 0
                    this.selectAnswer(false)
                }
            }
        },
      share(url){
        this.$emit('share', url)
      },
      selectAnswer(answer){
          const _this = this
        this.answers[this.page-1].answer = answer
        this.page++
        if(this.page === 5){
          this.showResult()
        }

          setTimeout(function () {
              _this.touch.enable = true
          }, 1000)
      },
      showResult(){

        let _this = this

        gsap.to('.rd-test',{opacity:0, duration:.3, onComplete:function () {
            _this.$emit('open-result')

            let count = _this.answers.filter(item => item.answer === true).length;

            if(count === 0){
              _this.star = 5
            }else{
              _this.star = 3
            }

            Vue.nextTick(function () {
              gsap.to('.rd-result',{opacity:1, duration:.3})
            })
          }})

        this.$emit('open-result')
      }
    },


    mounted() {
      gsap.to('.rd-test',{opacity:1, duration:.3})
    }
  }
</script>

